import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Tab,
  Tabs
}from 'react-bootstrap'

import ActivityReport from './reports/activityreport'
import LeadCountReport from './reports/leadcountreport'
import PaidInvoicesBySourceReport from './reports/paidinvoicesbysourcereport'

@observer(['globals'])
export default class Reports extends Component {

  constructor(props) {
    super(props)

    this.state = {
      sourceId: 0,
      sourceName: '',
      startDate: '',
      endDate: '',
      defaultTab: 1,
    }

    this.props.globals.setCurrentSubPage('reports')
  }

  componentWillMount() {
    const reports = JSON.parse(localStorage.getItem('crm-reports'));
    
    reports && reports.length > 0 && this.setState({
      sourceId: reports[0].sourceId,
      sourceName: reports[0].sourceName,
      startDate: reports[0].startDate,
      endDate: reports[0].endDate,
      defaultTab: reports[0].defaultTab,
    });
  }

  render() {
    let activityReportTab = ''
    let leadCountReportTab = ''
    let paidInvoicesBySourceTab = ''
    let accessLevel = localStorage.getItem('userAccessLevel')

    if ( accessLevel >= 15 ) {
      activityReportTab = (
        <Tab eventKey={ 1 } title="Activity Report">
          <div style={
            {
              marginBottom: '20px',
              borderLeft: '1px solid #DDD',
              borderBottom: '1px solid #DDD',
              borderRight: '1px solid #DDD',
              padding: '15px',
              backgroundColor: '#FFF'
            }
          }>
            <ActivityReport />
          </div>
        </Tab>
      )

      leadCountReportTab = (
        <Tab eventKey={ 2 } title="Lead Count Report">
          <div style={
            {
              marginBottom: '20px',
              borderLeft: '1px solid #DDD',
              borderBottom: '1px solid #DDD',
              borderRight: '1px solid #DDD',
              padding: '15px',
              backgroundColor: '#FFF'
            }
          }>
            <LeadCountReport />
          </div>
        </Tab>
      )
      
      paidInvoicesBySourceTab = (
        <Tab eventKey={ 3 } title="Paid Invoices By Source">
          <div style={
            {
              marginBottom: '20px',
              borderLeft: '1px solid #DDD',
              borderBottom: '1px solid #DDD',
              borderRight: '1px solid #DDD',
              padding: '15px',
              backgroundColor: '#FFF'
            }
          }>
            <PaidInvoicesBySourceReport sourceId={ this.state.sourceId } sourceName={ this.state.sourceName } startDate={ this.state.startDate } endDate={ this.state.endDate }/>
          </div>
        </Tab>
      )

    }

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
          </div>
          <div className="clearfix"></div>
          <Tabs defaultActiveKey={ this.state.defaultTab } id="site-options-tabs">
            { activityReportTab }
            { leadCountReportTab }
            { paidInvoicesBySourceTab }
            <Tab eventKey={ 4 } title="Coming soon...">
              <div style={
                {
                  marginBottom: '20px',
                  borderLeft: '1px solid #DDD',
                  borderBottom: '1px solid #DDD',
                  borderRight: '1px solid #DDD',
                  padding: '15px',
                  backgroundColor: '#FFF'
                }
              }>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/reports.js